import { createContext } from 'react';
import type { NOTIFICATION_DIALOG_ACTIONS } from './constants';
import type {
  NotificationDialogProps,
  NotificationDialogResult,
} from './types';

type NotificationDialogContextValue = {
  open: (props: NotificationDialogProps) => Promise<NotificationDialogResult>;
  close: (payload?: Partial<NotificationDialogResult>) => void;
  NOTIFICATION_DIALOG_ACTIONS: typeof NOTIFICATION_DIALOG_ACTIONS;
};

export const NotificationDialogContext =
  createContext<NotificationDialogContextValue | null>(null);
